import * as React from 'react';
import { Viewport } from 'react-leaflet';
import { FieldOverlay, FieldClickEventArgs } from './';
import { calculateFarmViewport } from '../utils';
import BaseMap from './BaseMap';

interface Props {
  farm: Farm;
  onFieldClick?: (args: FieldClickEventArgs) => void;
  selectedId?: string | null;
  className?: string;
  leafletRef?: (map: L.Map) => void;
  pinnedLayers?: Record<string, RasterDocument>;
  editSelected?: boolean;
  onSelectedEdit?: (geometry: PolygonGeometry) => void;
  hideSelected?: boolean;
  keyboard?: boolean;
  onReferenceClick?: (args: FieldClickEventArgs) => void;
}

interface State {
  customViewport: Viewport | null;
}

const DEFAULT_VIEWPORT: Viewport = {
  center: [-37.280609, -59.648724],
  zoom: 14
};

class FarmMap extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      customViewport: null
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.selectedId !== this.props.selectedId) {
      this.setState({ customViewport: null });
    }
  }

  renderField(field: Field) {
    const {
      selectedId,
      editSelected,
      onSelectedEdit,
      hideSelected,
      pinnedLayers,
      onFieldClick,
      onReferenceClick,
    } = this.props;

    const isSelected = field.id === selectedId;

    if (isSelected && hideSelected) {
      return null;
    }

    const pinnedLayer = pinnedLayers && pinnedLayers[field.id];

    return (
      <FieldOverlay
        selected={isSelected}
        editable={isSelected && editSelected}
        onEdit={isSelected ? onSelectedEdit : undefined}
        key={field.id}
        field={field}
        layer={pinnedLayer}
        onClick={onFieldClick}
        onReferenceClick={onReferenceClick}
      />
    );
  }

  render() {
    const {
      farm,
      selectedId,
      editSelected,
      pinnedLayers,
      onSelectedEdit,
      onFieldClick,
      children,
      leafletRef,
      keyboard,
      onReferenceClick,
      ...other
    } = this.props;

    const selectionViewport =
      calculateFarmViewport(farm, selectedId) || DEFAULT_VIEWPORT;

    return (
      <BaseMap
        keyboard={keyboard}
        leafletRef={leafletRef}
        viewport={selectionViewport}
        {...other}
      >
        {farm.fields.map(f => this.renderField(f))}
        {children}
      </BaseMap>
    );
  }
}

export default FarmMap;



// WEBPACK FOOTER //
// ./src/components/FarmMap.tsx